import { emitHealthFinding, } from "@wakeloop/agent-runtime";
export const emitRuntimeHealthFinding = (input) => {
    emitHealthFinding({
        eventName: input.eventName,
        fields: input.fields,
        finding: input.finding,
    });
};
